import React, { useState } from "react";
import "./legal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye} from "@fortawesome/free-solid-svg-icons";
function Gallerys() {
  const [selectedImage, setSelectedImage] = useState(null);

  const openImage = (img) => {
    setSelectedImage(img);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  return (
    <main>
         <div className="chitto">
        <div className="banner-contact">
          <img src="/img/company/review.jpg" alt="help" />
          <div className="banner-contact-box"></div>
          <div className="contactus-header">
        <h1>Gallery</h1>
        <p>Explore Photos and Video From Guests</p>
      </div>
      </div>
      </div>
    <div className="legal-container">
   

      <div className="legal-grid">
        {/* PAN CARD */}
        <div className="legal-card" onClick={() => openImage("/img/chitwan/chitwan1dslr.jpeg")}>
          <img src="/img/chitwan/chitwan1dslr.jpeg" alt="Pan Card" />
          <p>(View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>

        {/* TOUR LICENSE */}
        <div className="legal-card" onClick={() => openImage("/img/pokhara/pokhara3dslr.jpeg")}>
          <img src="/img/pokhara/pokhara3dslr.jpeg" alt="Pan Card" />
          <p>(View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>

        {/* COMPANY LICENSE */}
        <div className="legal-card" onClick={() => openImage("/img/capital/myself.jpg")}>
          <img src="/img/capital/myself.jpg" alt="Pan Card" />
          <p>(View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>
        <div className="legal-card" onClick={() => openImage("/img/company/mewith.jpeg")}>
          <img src="/img/company/mewith.jpeg" alt="Pan Card" />
          <p>(View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>
        {/* SECOND COMPANY LICENSE */}
        <div className="legal-card" onClick={() => openImage("/img/capital/pro.png")}>
          <img src="/img/capital/pro.png" alt="Pan Card" />
          <p>(View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>
        <div className="legal-card" onClick={() => openImage("/img/chitwan/chitwan2dslr.jpeg")}>
          <img src="/img/chitwan/chitwan2dslr.jpeg" alt="Pan Card" />
          <p>(View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>
        <div className="legal-card" onClick={() => openImage("/img/chitwan/chitwan3dslr.jpeg")}>
          <img src="/img/chitwan/chitwan3dslr.jpeg" alt="Pan Card" />
          <p>(View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>
        <div className="legal-card" onClick={() => openImage("/img/chitwan/chitwan5dslr.jpeg")}>
          <img src="/img/chitwan/chitwan5dslr.jpeg" alt="Pan Card" />
          <p>(View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>
        <div className="legal-card" onClick={() => openImage("/img/chitwan/chitwan6dslr.jpeg")}>
          <img src="/img/chitwan/chitwan6dslr.jpeg" alt="Pan Card" />
          <p>(View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>
        <div className="legal-card" onClick={() => openImage("/img/chitwan/chitwan7dslr.jpeg")}>
          <img src="/img/chitwan/chitwan7dslr.jpeg" alt="Pan Card" />
          <p>(View Now)<FontAwesomeIcon icon={faEye}></FontAwesomeIcon></p>
        </div>
        
      </div>

      {/* MODAL */}
      {selectedImage && (
        <div className="legal-modal">
          <span className="legal-close" onClick={closeImage}>
            &times;
          </span>
          <img src={selectedImage} alt="Large View" />
        </div>
      )}
    </div>
    </main>
  );
}

export default Gallerys;